import { useMemo } from 'react';
import { formatShortDate, getTodayIso } from '@odo/shared-ui';
import { useUser } from '../../../../../../providers/UserProvider';

interface SignOffIdentity {
    name: string;
    date: string;
}

// Display only: the server stamps the real signer and time.
function useSignOffIdentity(): SignOffIdentity {
    const { user } = useUser();
    const name = user?.name || user?.email || 'you';
    const date = useMemo(() => formatShortDate(getTodayIso()), []);
    return { name, date };
}

export { useSignOffIdentity };
